const mainRu = {
  projectText:
    "Консультант по причинно-следственным связям и мастер матрицы судьбы",
  heroChoose: 'Больше никаких сомнений в себе и в "магии" своих поступков.',
  heroButton1: "Перейти к услугам",
  heroButton2: "Калькулятор матрицы",
  projectAuthor: "Образование",
  authroDesc:
    "<0>Дарина Дупак — </0>профессиональный инициированный консультант по предназначению, диагностике и коррекции судьбы",
  aboutAuthorWork1: "Дипломированный менеджер социокультурной деятельности",
  aboutAuthorWork2:
    "Работаю над созданием личностных брендов, провожу трансформационные ивенты.",
  aboutAuthorWork3:
    "Работаю по авторскому методу Наталии Ладини, известного как Матрица Судьбы",
  aboutAuthorWork4:
    "Владею углублёнными расчётами метода и техниками исцеления.",
  aboutAuthorWork5:
    "Получила магистерскую степень по психологии в Таврическом национальном университете имени В. И. Вернадского",
  aboutAuthorWork6:
    "Изучаю кармический менеджмент и причинно-следственные связи в Институте Азиатской Классики",
  aboutKarmaTitle: "ТЫ — и есть настоящая карма",
  aboutKarmaDesc1:
    'Карма — это ход твоих мыслей, движение ума, а не наказание или "обратка"',
  aboutKarmaDesc2:
    "Алмазная Мудрость — система достижения целей через этичные и добрые поступки",
  aboutKarmaNearHands:
    "Мысли, речь, поступки — всё это действия, которые ты совершаешь ежедневно, большинство даже на автомате. И именно они формируют твоё восприятие: кто для тебя «хороший» или «плохой», а что — проблема или возможность.",
  aboutKarmaTextUnderContainer: "И это хорошая новость — ведь если так...",
  aboutKarmaResultText: "Твоя судьба реально в твоих руках!",
  whatIsMatrixTitle1: "Что такое",
  whatIsMatrixTitle2: "Матрица Судьбы?",
  whatIsMatrixMatrixCreator: "Метод Наталии Ладини, которому более 20 лет. ",
  whatIsMatrixAboutMethod:
    "Этот метод фактически является зеркалом ваших жизненных сценариев, отражённых в 22 архетипах. Это уникальный инструмент для исследования предназначения и коррекции жизни через поступки и новые привычки.",
  whatIsMatrixLinkToCalculator: "Расчитать свою матрицу бесплатно",
  matrixMinusAndPlusTitle1: "Матрица в минусе",
  matrixMinusAndPlusTitle2: "Матрица в плюсе",
  matrixMinusAndPlusCheckboxText: "Проработать матрицу",
  matrxiMinusPuzzle: "испытываешь финансовые трудности",
  waysToTransformationTitle: "Я проведу тебя к истинным желаниям твоей души",
  waysToTransformationAbout:
    "Ты не останешься один с багажом новой информации о себе - так как я гарантирую:",
  waysToTransformationWarning:
    "*Беспечное вскрытие судьбоносных программ, без готовности работать над ними, чревато последствиями. Поэтому для вашей безопасности и блага все полноценные разборы матрицы НЕ проводятся без готовности идти в трансформацию.",
  waysToTransformationConsultationTitle: "На Консультации",
  waysToTransformationConsultationText1:
    "Индивидуальный подход к каждой душе и её жизненным проблемам",
  waysToTransformationConsultationText2:
    "Уникальные трактовки соединений энергий в твоей матрице",
  waysToTransformationConsultationText3:
    "Информацию, которая со временем раскроется в новом, глубинном ключе",
  waysToTransformationTransformationWayTitle: "На Трансформации",
  waysToTransformationTransformationWayText1:
    "Энергетическую и информационную поддержку.",
  waysToTransformationTransformationWayText2:
    "Предоставление комплекса рекомендаций и материалов - кармический рецепт",
  waysToTransformationTransformationWayText3:
    "Разноплановые методики и практики для проработки",
  waysToTransformationTransformationWayText4:
    "Отслеживание процесса трансформации с помощью точек контроля между этапами в формате созвонов.",
  ServicesAndPriceTitle: "Услуги",
  ServicesTypesInfo:
    "Данные три типа консультации подходят под любой запрос. Просто выбери формат, в котором готов работать, и приходи. Всё остальное от инструмента до необходимых расчётов подберу я.",
  ServicesAndPriceFourStages: "Матрица Судьбы: все уровни оригинального метода",
  ServicesAndPriceWarning: "*Каждый уровень прорабатывается последовательно",
  ServicesAndPriceDetail: "Подробнее",
  ServicesAndPriceConsultationsIndividualRequest:
    "Также вы можете разобрать проблему по индивидуальному запросу",
  ServicesAndPriceConsultationsTitle: "Особые форматы",
  ServicesAndPriceExpressServicesTitle: "Экспресс-услуги",
  ServicesAndPriceExpressServicesAdditionalInfo1:
    "Также вы можете подарить своим близким",
  ServicesAndPriceExpressServicesAdditionalInfo2: "на любую услугу.",
  ServicesAndPriceExpressServicesCert: "сертификат",
  masterClassTitle: "Материалы для <1>самостоятельной работы</1>",
  cost: "Стоимость:",
  feedback: "Отзывы",
  feedbackDesc:
    "Я буду рада стать твоим проводником в новом этапе твоей жизни!",
  moreFeedbacks: "Больше отзывов",
  calculate: "Рассчитай",
  yourMatrix: "свою Матрицу Судьбы",
  aboutCalc:
    "Получи правильный расчёт по оригинальному методу Натальи Ладини — от базовой Матрицы до глубинных уровней.",
  infoAboutCalc:
    "* Калькулятор на 100% соответствует классическим расчётам метода «Матрица Судьбы» Наталии Ладини",
  calcBtn: "Рассчитать",
  freeRecommendationTitle: "Бесплатно делюсь полезностями в соц. сетях:",
  peopleAsk: "Меня часто спрашивают",
  FourLevels: "Услуги",
  aboutMethods: "О Матрице",
  services: { buy_button: "Записаться", include: "Включает" },
};

export default mainRu;
